const apps = otto.apps;
export {
  apps
};
/*🤫*/
